import { AxiosInstance } from 'axios';

import { cwaUrl } from '/configuration';

const TRY_SLEEP = [1, 1, 1, 2, 4, 8, 8, 8];

const fileDownload = async (
  cwaAxios: AxiosInstance,
  url: string,
): Promise<void> => {
  let resp = null;
  let statusId = null;

  for (let i = 0; i < 30; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    resp = await cwaAxios.get(
      url,
      statusId ? { params: { statusId } } : undefined,
    );

    if (resp.data.downloadUrl) {
      window.location.href = `${
        resp.data.downloadUrl.startsWith('/') ? cwaUrl : ''
      }${resp.data.downloadUrl}`;
      return;
    }

    if (['failed', 'aborted'].includes(resp.data.state)) {
      throw new Error(`Download ${resp.data.state}`);
    }

    if (i === 0) {
      // eslint-disable-next-line prefer-destructuring
      statusId = resp.data.statusId;
      if (!statusId) {
        throw new Error(`No statusId: ${JSON.stringify(resp)}`);
      }
    }

    const sleep = (TRY_SLEEP[i] || 16) * 1000;
    // eslint-disable-next-line no-await-in-loop
    await new Promise((res) => setTimeout(res, sleep));
  }

  throw new Error('Too many tries.');
};

export default fileDownload;
